import React, { useState, useEffect } from 'react';
import { useApp } from '../contexts/AppContext';
import { api } from '../api/client';
import { toast } from './UI';

export default function AuthPage() {
  const { login, register } = useApp();
  const [needsSetup, setNeedsSetup] = useState(null);
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.authStatus().then(r => setNeedsSetup(r.needsSetup)).catch(() => setNeedsSetup(false));
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (needsSetup) await register(form.email, form.password, form.name);
      else await login(form.email, form.password);
    } catch (err) {
      toast(err.message, 'error');
    } finally { setLoading(false); }
  };

  if (needsSetup === null) return null;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 48, fontWeight: 400, color: 'var(--accent)', letterSpacing: -1 }}>Work</h1>
          <p style={{ color: 'var(--text-3)', fontSize: 14, marginTop: 4 }}>Dein persönliches Betriebssystem</p>
        </div>

        <div className="card" style={{ padding: 28 }}>
          <h2 style={{ fontFamily: 'var(--font-serif)', fontWeight: 400, fontSize: 22, marginBottom: 20 }}>
            {needsSetup ? 'Account einrichten' : 'Anmelden'}
          </h2>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {needsSetup && (
              <div className="form-group">
                <label>Name</label>
                <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="Dein Name" required />
              </div>
            )}
            <div className="form-group">
              <label>E-Mail</label>
              <input type="email" value={form.email} onChange={e => set('email', e.target.value)} required autoFocus />
            </div>
            <div className="form-group">
              <label>Passwort</label>
              <input type="password" value={form.password} onChange={e => set('password', e.target.value)} required minLength={8} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 8 }}>
              {loading ? '...' : needsSetup ? 'Account erstellen' : 'Anmelden'}
            </button>
          </form>
          {needsSetup && (
            <p style={{ color: 'var(--text-3)', fontSize: 12, marginTop: 16, textAlign: 'center' }}>
              Dieser Account ist ausschließlich für dich. Nach der Registrierung sind keine weiteren Accounts möglich.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
